module.exports = __webpack_public_path__ + "static/media/PasswordLock.62d9841f.svg";